import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from '@outdoor-voices/ui';
import PhoneInput from 'react-phone-input-labelled';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DT } from '../../config/constants';
import { OV_CONCIERGE_API_KEY, OV_CONCIERGE_MODE, OV_CONCIERGE_OPT_IN_URL, PHONE_COUNTRIES, PHONE_DEFAULT_PLACEHOLDER, SMS_OPT_IN_DEFAULT_CONFIG, PHONE_NUMBER_LENGTH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ConciergeSignUp = function ConciergeSignUp(_ref) {
  var options = _ref.options,
      configuration = _ref.configuration;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setValid = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitted = _useState6[0],
      setSubmitted = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      submitting = _useState8[0],
      setSubmitting = _useState8[1];

  var CONFIG = Object.assign(SMS_OPT_IN_DEFAULT_CONFIG, _objectSpread({}, configuration));

  var replaceTag = function replaceTag(text) {
    return text.replace('{{org_name}}', CONFIG.orgName);
  };

  var onSuccess = function onSuccess() {
    configuration.onSuccess && configuration.onSuccess();
  };

  var onError = function onError() {
    configuration.onError && configuration.onError();
  };

  var onPhoneChange = function onPhoneChange(phoneNumberValue) {
    setValid(isPhoneValid(phoneNumberValue));
    setValue(phoneNumberValue);
  };

  var isPhoneValid = function isPhoneValid(phoneNumber) {
    var matchNumbers = phoneNumber.match(/\d/g);
    return matchNumbers && matchNumbers.length === PHONE_NUMBER_LENGTH;
  };

  var submitButton = function submitButton() {
    if (submitted) {
      return /*#__PURE__*/_jsx("p", {
        children: CONFIG.successText
      });
    }

    return /*#__PURE__*/_jsx(Button, {
      disabled: !isValid || submitting,
      big: true,
      type: "submit",
      children: submitting ? DT : CONFIG.buttonText
    });
  };

  var submitForm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              setSubmitting(true);
              options.mode = OV_CONCIERGE_MODE;
              options.pk = OV_CONCIERGE_API_KEY;
              options.phone_number = value;
              _context.prev = 5;
              _context.next = 8;
              return fetch(OV_CONCIERGE_OPT_IN_URL, {
                body: JSON.stringify(options),
                headers: {
                  accept: 'application/json, text/plain, */*',
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 8:
              setSubmitted(true);
              onSuccess();
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              console.error(_context.t0);
              onError();

            case 16:
              setSubmitting(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }));

    return function submitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx("div", {
    className: "concierge-form-container",
    style: CONFIG.formContainerStyle,
    children: /*#__PURE__*/_jsxs("form", {
      id: "concierge-sms-opt-in-form",
      onSubmit: submitForm,
      children: [/*#__PURE__*/_jsx("p", {
        className: "concierge-header",
        style: CONFIG.headerStyle,
        children: CONFIG.header
      }), /*#__PURE__*/_jsx("p", {
        className: "concierge-subheader",
        style: CONFIG.subheaderStyle,
        children: CONFIG.subheader
      }), /*#__PURE__*/_jsx(PhoneInput, {
        defaultCountry: "us",
        disableCountryCode: true,
        disableDropdown: true,
        disableSearchIcon: true,
        enableSearchField: false,
        label: null,
        value: value,
        inputExtraProps: {
          name: 'phone',
          required: true,
          style: CONFIG.phoneInputStyle
        },
        onChange: onPhoneChange,
        placeholder: PHONE_DEFAULT_PLACEHOLDER,
        searchPlaceholder: PHONE_DEFAULT_PLACEHOLDER,
        onlyCountries: PHONE_COUNTRIES
      }), submitButton(), /*#__PURE__*/_jsx("p", {
        style: CONFIG.smsLegalNoticeStyle,
        children: replaceTag(CONFIG.smsLegalNotice)
      })]
    })
  });
};

ConciergeSignUp.propTypes = {
  options: PropTypes.shape({
    mode: PropTypes.string,
    pk: PropTypes.string,
    phone_number: PropTypes.string
  }).isRequired,
  configuration: PropTypes.shape({
    onError: PropTypes.func,
    onSuccess: PropTypes.func
  }).isRequired
};
export default ConciergeSignUp;